export const slugs = {
  state: {
    mapping: {},
  },

  mutations: {
    setSlugsMapping(state, slugsMapping) {
      state.mapping = slugsMapping
    },
  },

  actions: {
    getMappingFromPois({ rootState }, pois) {
      const slugsMapping = {}
      const { locales } = rootState

      for (const poi of pois) {
        for (const locale of locales) {
          if (!slugsMapping[locale]) slugsMapping[locale] = []

          slugsMapping[locale].push({
            id: poi.id,
            slug : poi.slug[locale],
          })
        }
      }

      return slugsMapping
    },

    getIdFromSlug({ state }, { slug, locale }) {
      const mapping = state.mapping[locale].find((map) => map.slug === slug)

      return mapping.id
    },

    getSlugFromId({ state }, { id, locale }) {
      const mapping = state.mapping[locale].find((map) => map.id === id)

      return mapping.slug
    }
  },
}
